import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';

import Box from '../box/box.jsx';

import styles from './connection-modal.css';

const labels = {
    authorized: '授权状态',
    authorizedNo: '未授权',
    authorizedYes: '已授权',
    cloudState: '云端状态',
    connect: '连接',
    connecting: '连接中...',
    connectionStatus: '连接状态',
    deviceCode: '设备编码',
    disconnect: '断开'
};

const getStatusText = (status, connecting) => {
    if (status.cloudState === 'rejected' || status.deviceStatus === '被拒绝') return '被拒绝';
    if (status.deviceStatus === '未授权') return '未授权';
    if (connecting || status.cloudState === 'connecting' || status.deviceStatus === '连接中') return '连接中';
    if (status.isConnected && status.authorized) return '已连接';
    if (status.deviceStatus === '已断开') return '已断开';
    return status.deviceStatus || '未连接';
};

const getStatusClass = statusText => {
    if (statusText === '已连接') return styles.xiaozhiStatusOnline;
    if (statusText === '连接中') return styles.xiaozhiStatusConnecting;
    if (statusText === '未授权' || statusText === '被拒绝') return styles.xiaozhiStatusError;
    return styles.xiaozhiStatusOffline;
};

class XiaozhiCloudStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange',
            'handleSubmit'
        ]);
        this.state = {
            deviceCode: props.status.deviceCode || ''
        };
    }
    handleChange (e) {
        this.setState({deviceCode: e.target.value});
    }
    handleSubmit (e) {
        e.preventDefault();
        this.props.onConnect(this.state.deviceCode);
    }
    render () {
        const statusText = getStatusText(this.props.status, this.props.connecting);
        return (
            <Box className={styles.body}>
                <form onSubmit={this.handleSubmit}>
                    <Box className={classNames(styles.activityArea, styles.xiaozhiActivityArea)}>
                        <div className={styles.xiaozhiCloudPanel}>
                            <div className={styles.xiaozhiStatusRow}>
                                <span className={styles.xiaozhiStatusLabel}>{labels.connectionStatus}</span>
                                <span className={classNames(styles.xiaozhiStatusBadge, getStatusClass(statusText))}>
                                    {statusText}
                                </span>
                            </div>
                            <div className={styles.xiaozhiStatusGrid}>
                                <span>{labels.deviceCode}</span>
                                <strong>{this.props.status.deviceCode || '-'}</strong>
                                <span>{labels.cloudState}</span>
                                <strong>{this.props.status.cloudState || '-'}</strong>
                                <span>{labels.authorized}</span>
                                <strong>
                                    {this.props.status.authorized ? labels.authorizedYes : labels.authorizedNo}
                                </strong>
                            </div>
                        </div>
                    </Box>
                    <Box className={styles.bottomArea}>
                        <label
                            className={classNames(styles.bottomAreaItem, styles.xiaozhiInputLabel)}
                            htmlFor="xiaozhi-device-code-input"
                        >
                            {labels.deviceCode}
                        </label>
                        <input
                            autoFocus
                            className={styles.xiaozhiInput}
                            disabled={this.props.connecting}
                            id="xiaozhi-device-code-input"
                            placeholder="RPI-99ED0370F987"
                            type="text"
                            value={this.state.deviceCode}
                            onChange={this.handleChange}
                        />
                        {this.props.error ? (
                            <div className={styles.xiaozhiError}>
                                {this.props.error}
                            </div>
                        ) : null}
                        <div className={classNames(styles.bottomAreaItem, styles.cornerButtons)}>
                            <button
                                className={classNames(styles.redButton, styles.connectionButton)}
                                disabled={this.props.connecting}
                                type="button"
                                onClick={this.props.onDisconnect}
                            >
                                {labels.disconnect}
                            </button>
                            <button
                                className={styles.connectionButton}
                                disabled={this.props.connecting}
                                type="submit"
                            >
                                {this.props.connecting ? labels.connecting : labels.connect}
                            </button>
                        </div>
                    </Box>
                </form>
            </Box>
        );
    }
}

XiaozhiCloudStep.propTypes = {
    connecting: PropTypes.bool,
    error: PropTypes.string,
    onConnect: PropTypes.func.isRequired,
    onDisconnect: PropTypes.func.isRequired,
    status: PropTypes.shape({
        authorized: PropTypes.bool,
        cloudState: PropTypes.string,
        deviceCode: PropTypes.string,
        deviceStatus: PropTypes.string,
        isConnected: PropTypes.bool
    })
};

XiaozhiCloudStep.defaultProps = {
    connecting: false,
    error: null,
    status: {}
};

export default XiaozhiCloudStep;
